import { render, staticRenderFns } from "./ResetLinkSent.vue?vue&type=template&id=541d066c&scoped=true&"
import script from "./ResetLinkSent.vue?vue&type=script&lang=js&"
export * from "./ResetLinkSent.vue?vue&type=script&lang=js&"
import style0 from "./ResetLinkSent.vue?vue&type=style&index=0&id=541d066c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d066c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardActions,VContainer,VFlex,VForm,VLayout,VMain})
